// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"MenuOpener_headerIcon__2EuVM","headerTextIcon":"MenuOpener_headerTextIcon__3Ydhh","menuOpener":"MenuOpener_menuOpener__3NhO3"};